module.exports = __webpack_public_path__ + "static/clients-autibooks-93f27c4918e7581c67f8f8356b707e0d.svg";